<template>
  <v-form lazy-validation v-model="validForm" ref="formulaireResultatBac">
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <br />
    <br />
    <div v-html="texte"></div>
    <br />
    <br />
    <!-- Code massar -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac ===
        $storeCatalogue.DataId.TypeBacMarocain
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-mask="$storeCommun.MaskCodeMassar"
          v-model="$storeResultatBac.data.codeMassarResultat"
          :label="$storeUniversite.label.CodeEtudiant"
          outlined
          :rules="[$rules.alphaNumerique(), $rules.codeMassarFormat()]"
          :disabled="$storeResultatBac.data.readOnly"
          :hint="$storeUniversite.label.HintCodeMassar"
          persistent-hint
          class="asterisk"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-mask="$storeCommun.MaskCodeMassar"
          v-model="$storeResultatBac.data.confirmCodeMassarResultat"
          :label="$storeUniversite.label.ConfirmCodeEtudiant"
          outlined
          :rules="[$rules.Equal($storeResultatBac.data.codeMassarResultat)]"
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
          @paste.prevent
          @copy.prevent
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          v-model="$storeResultatBac.data.avezVousObtenuVotreDiplome"
          :item-text="$storeUniversite.itemLang"
          item-value="id"
          :items="$storeCatalogue.OuiNon"
          :label="$storeUniversite.label.ObtentionBac"
          outlined
          :rules="[$rules.obligatoire()]"
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <!-- Bareme -->
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          v-if="
            $storeResultatBac.data.typeDeBac !==
            $storeCatalogue.DataId.TypeBacMarocain
          "
          v-model="$storeResultatBac.data.systemeNotationBac"
          :item-text="$storeUniversite.itemLang"
          item-value="id"
          :items="$storeCatalogue.SystemeNotationBac"
          :label="$storeUniversite.label.SystemeNotationBac"
          outlined
          :rules="
            $storeResultatBac.data.typeDeBac !==
            $storeCatalogue.DataId.TypeBacMarocain
              ? [$rules.obligatoire()]
              : []
          "
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          v-model="$storeResultatBac.data.baremeDeNotationAuBac"
          :item-text="$storeUniversite.itemLang"
          item-value="id"
          :items="$storeCatalogue.BaremBac"
          :label="$storeUniversite.label.BaremeNote"
          outlined
          :disabled="
            $storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.TypeBacMarocain ||
            $storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.TypeBacFrancais ||
            $storeResultatBac.data.readOnly
          "
          :rules="
            $storeResultatBac.data.typeDeBac ===
            $storeCatalogue.DataId.TypeBacAutre
              ? [$rules.obligatoire()]
              : []
          "
          class="asterisk"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.baremeDeNotationAuBac ===
          $storeCatalogue.DataId.BaremBacAutre
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.specificationDuBaremeDeBac"
          :label="$storeUniversite.label.SpecificationBaremBac"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :rules="[$rules.obligatoire()]"
          class="asterisk"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      v-if="
        $storeResultatBac.data.baremeDeNotationAuBac ===
        $storeCatalogue.DataId.BaremBacAutre
      "
    >
      <v-col cols="12">
        <p>{{ $storeUniversite.label.Abcd }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.moyGenDuBac"
          :label="$storeUniversite.label.MoyGenAnnuelleBac"
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="$storeResultatBac.data.moyenneSem1Trim1Bac"
          dense
          :label="$storeUniversite.label.MoyenneSem1Trim1Bac"
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- BAC FRANCAIS -->
    <!-- SPECIALITE 1 -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac ===
        $storeCatalogue.DataId.TypeBacFrancais
      "
    >
      <v-col cols="6">
        <v-autocomplete
          dense
          v-model="$storeResultatBac.data.specialite1"
          :item-text="$storeUniversite.itemLang"
          item-value="id"
          :items="$storeCatalogue.Specialite1Bac"
          :label="$storeUniversite.label.Spécialite1"
          :rules="[$rules.obligatoire()]"
          class="asterisk"
          @change="CheckSpecialite2($storeResultatBac.data.specialite1)"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.noteSpecialite1"
          :label="$storeUniversite.label.Specialite1note"
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- BAC FRANCAIS -->
    <!-- SPECIALITE 2 -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac ===
        $storeCatalogue.DataId.TypeBacFrancais
      "
    >
      <v-col cols="6">
        <v-autocomplete
          dense
          v-model="$storeResultatBac.data.specialite2"
          :item-text="$storeUniversite.itemLang"
          item-value="id"
          :items="$storeCatalogue.Specialite2Bac"
          :label="$storeUniversite.label.Specialite2"
          :rules="[$rules.obligatoire()]"
          class="asterisk"
          @change="CheckSpecialite1($storeResultatBac.data.specialite2)"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.noteSpecialite2"
          :label="$storeUniversite.label.Specialite2note"
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- BAC FRANCAIS -->
    <!-- MATH EXPERT OPTION -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac ===
        $storeCatalogue.DataId.TypeBacFrancais
      "
    >
      <v-col cols="6">
        <v-autocomplete
          dense
          v-model="$storeResultatBac.data.mathsExpertOption"
          :item-text="$storeUniversite.itemLang"
          item-value="id"
          :items="$storeCatalogue.OuiNon"
          :label="$storeUniversite.label.MathsExpertOption"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :rules="[$rules.obligatoire()]"
          class="asterisk"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.avezVousObtenuVotreDiplome ===
            $storeCatalogue.DataId.Oui &&
          $storeResultatBac.data.mathsExpertOption ===
            $storeCatalogue.DataId.Oui
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.noteMathsExpertOption"
          :label="$storeUniversite.label.MathsExpertNote"
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.typeDeBac !== $storeCatalogue.DataId.AutreBac
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.moy1erAnneeBac"
          :label="
            $storeUniversite.displayLabel($storeResultatBac.data.typeDeBac)
          "
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
      <v-col cols="6" v-else>
        <v-text-field
          dense
          v-model="$storeResultatBac.data.moyGen2EmeAnneeCycleLycee"
          :label="$storeUniversite.label.MoyGen2eCycleLycee"
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
      <!-- BAC MAROCAIN -->
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.typeDeBac ===
          $storeCatalogue.DataId.TypeBacMarocain
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.noteBacRegional"
          :label="$storeUniversite.label.MoyenneExamenRegional"
          outlined
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- BAC AUTRE ET DOMAINE AUTRE -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac === $storeCatalogue.DataId.AutreBac &&
        !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
          $storeResultatBac.data.domaineDuBaccalaureat
        )
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.math1erBacSemestre1"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Math1BacSem1
              : $storeUniversite.label.Math1BacSem1Autre
          "
          outlined
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique),
          }"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.math1erBacSemestre2"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Math1BacSem2
              : $storeUniversite.label.Math1BacSem2Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique),
          }"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac === $storeCatalogue.DataId.AutreBac &&
        !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
          $storeResultatBac.data.domaineDuBaccalaureat
        )
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.maths1ErBacTrim3"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Math1BacTrimestre3
              : $storeUniversite.label.Math1BacTrimestre3Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !== $storeCatalogue.DataId.AutreBac
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac,
          }"
        ></v-text-field>
      </v-col>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.math2erBacSemestre1"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Math2BacSem1
              : $storeUniversite.label.Math2BacSem1Autre
          "
          outlined
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique &&
              $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                $storeCatalogue.DataId.Oui)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique &&
                $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                  $storeCatalogue.DataId.Oui),
          }"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac === $storeCatalogue.DataId.AutreBac &&
        !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
          $storeResultatBac.data.domaineDuBaccalaureat
        ) &&
        $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.math2erBacSemestre2"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Math2BacSem2
              : $storeUniversite.label.Math2BacSem2Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique &&
              $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                $storeCatalogue.DataId.Oui)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique &&
                $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                  $storeCatalogue.DataId.Oui),
          }"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.maths2EmeBacTrim3"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Maths2BacTrim3
              : $storeUniversite.label.Maths2BacTrim3Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !== $storeCatalogue.DataId.AutreBac
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac,
          }"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- BAC MAROCAIN -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac ===
          $storeCatalogue.DataId.TypeBacMarocain &&
        $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.moyenneCcAnneeBac"
          :label="$storeUniversite.label.MoyenneCcAnneeBac"
          :rules="
            $storeResultatBac.data.avezVousObtenuVotreDiplome ===
            $storeCatalogue.DataId.Oui
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.avezVousObtenuVotreDiplome ===
              $storeCatalogue.DataId.Oui,
          }"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.noteDuBacNational"
          :label="$storeUniversite.label.MoyenneNationalBac"
          outlined
          :rules="[
            $rules.obligatoire(),
            $rules.EstNumerique(),
            $rules.loanMin(ValeurBaremBac),
          ]"
          :disabled="$storeResultatBac.data.readOnly"
          class="asterisk"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- BAC MAROCAIN -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac ===
          $storeCatalogue.DataId.TypeBacMarocain &&
        !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
          $storeResultatBac.data.domaineDuBaccalaureat
        ) &&
        $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.mathsNational"
          :label="$storeUniversite.label.MathNational"
          outlined
          :rules="
            $storeResultatBac.data.domaineDuBaccalaureat !==
            $storeCatalogue.DataId.AutreFiliereBac
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          :disabled="$storeResultatBac.data.readOnly"
          :class="
            $storeResultatBac.data.domaineDuBaccalaureat !==
            $storeCatalogue.DataId.AutreFiliereBac
              ? 'asterisk'
              : ''
          "
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.physiqueNational"
          :label="$storeUniversite.label.PhysiqueNational"
          outlined
          :rules="
            $storeResultatBac.data.domaineDuBaccalaureat !==
            $storeCatalogue.DataId.AutreFiliereBac
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.domaineDuBaccalaureat !==
              $storeCatalogue.DataId.AutreFiliereBac,
          }"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- AUTRE BAC -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac === $storeCatalogue.DataId.AutreBac &&
        !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
          $storeResultatBac.data.domaineDuBaccalaureat
        )
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.physique1erBacSemestre1"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Physique1BacSem1
              : $storeUniversite.label.Physique1BacSem1Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique),
          }"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.physique1erBacSemestre2"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Physique1BacSem2
              : $storeUniversite.label.Physique1BacSem2Autre
          "
          outlined
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique),
          }"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- AUTRE BAC -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac === $storeCatalogue.DataId.AutreBac &&
        !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
          $storeResultatBac.data.domaineDuBaccalaureat
        )
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.physique1ErBacTrim3"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Physique1BacTrim3
              : $storeUniversite.label.Physique1BacTrim3Autre
          "
          outlined
          :rules="
            $storeResultatBac.data.typeDeBac !== $storeCatalogue.DataId.AutreBac
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac,
          }"
        ></v-text-field>
      </v-col>
      <v-col
        cols="6"
        v-if="
          $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
        "
      >
        <v-text-field
          dense
          v-model="$storeResultatBac.data.physique2erBacSemestre1"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Physique2BacSem1
              : $storeUniversite.label.Physique2BacSem1Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique &&
              $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                $storeCatalogue.DataId.Oui)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique &&
                $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                  $storeCatalogue.DataId.Oui),
          }"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- AUTRE BAC -->
    <v-row
      v-if="
        $storeResultatBac.data.typeDeBac === $storeCatalogue.DataId.AutreBac &&
        !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
          $storeResultatBac.data.domaineDuBaccalaureat
        ) &&
        $storeResultatBac.data.avezVousObtenuVotreDiplome ===
          $storeCatalogue.DataId.Oui
      "
    >
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.physique2erBacSemestre2"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Physique2BacSem2
              : $storeUniversite.label.Physique2BacSem2Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac ||
            ($storeResultatBac.data.typeDeBac ===
              $storeCatalogue.DataId.AutreBac &&
              $storeResultatBac.data.domaineDuBaccalaureat ===
                $storeCatalogue.DataId.EquivalentScientifique &&
              $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                $storeCatalogue.DataId.Oui)
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
                $storeCatalogue.DataId.AutreBac ||
              ($storeResultatBac.data.typeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
                $storeResultatBac.data.domaineDuBaccalaureat ===
                  $storeCatalogue.DataId.EquivalentScientifique &&
                $storeResultatBac.data.avezVousObtenuVotreDiplome ===
                  $storeCatalogue.DataId.Oui),
          }"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="$storeResultatBac.data.physique2EmeBacTrim3"
          :label="
            $storeResultatBac.data.typeDeBac != $storeCatalogue.DataId.AutreBac
              ? $storeUniversite.label.Physique2BacTrim3
              : $storeUniversite.label.Physique2BacTrim3Autre
          "
          :rules="
            $storeResultatBac.data.typeDeBac !== $storeCatalogue.DataId.AutreBac
              ? [
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]
              : [$rules.EstNumerique()]
          "
          outlined
          :disabled="$storeResultatBac.data.readOnly"
          :class="{
            asterisk:
              $storeResultatBac.data.typeDeBac !==
              $storeCatalogue.DataId.AutreBac,
          }"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Annexes -->
    <AnnexeComponent ref="childAnnexe" />
    <!-- Bouton validation -->
    <br />
    <br />
    <v-row>
      <v-col cols="6">
        <v-alert :type="alert.type" dense outlined v-show="alert.show">
          {{ alert.texte }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!$storeResultatBac.data.readOnly">
      <v-col cols="12" class="text-center">
        <v-btn class="pa-2" dark color="secondary" @click="Valider">
          {{ $storeUniversite.label.ValiderNotes }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AnnexeComponent from "@/components/InscriptionUniversite/AnnexesInscrUm6pComponent.vue";
export default {
  name: "ResultatsBac",
  components: {
    AnnexeComponent,
  },
  data() {
    return {
      alert: {
        show: false,
        texte: "",
        type: "error",
      },
      validForm: true,
      $storeCatalogue: this.$storeCatalogue,
      $storeResultatBac: this.$storeResultatBac,
      $storeCommun: this.$storeCommun,
      loader: true,
      texte: "Resultats bac",
    };
  },
  async mounted() {
    let token = this.$route.query.t;
    this.loader = true;
    if (token) {
      this.$storeResultatBac.token = token.replace(/\s/g, "+");
    }

    await this.$storeCatalogue.ChargerCataloguesInscriptionUniversite();
    const reponse = await this.$storeResultatBac.getData();

    if(reponse && reponse != "error"){
      this.$storeResultatBac.data = reponse.dto;
      if (reponse.texte) {
        this.texte = reponse.texte;
      }
      this.$refs.childAnnexe.ChargerAnnexesResultatBac(
        this.$storeResultatBac.data.idCrypte
      );
    }
    else{
      this.$router.push("/NonConnecte");
    }
    
    this.loader = false;
  },
  computed: {
    ValeurBaremBac() {
      return this.$storeUniversite.noteBacMaxAutorise(
        this.$storeResultatBac.data.baremeDeNotationAuBac,
        this.$storeResultatBac.data.specificationDuBaremeDeBac,
        this.$storeCatalogue
      );
    },
  },
  methods: {
    Valider() {
      this.alert.show = false;
      this.validForm = false;
      this.validForm = this.$refs.formulaireResultatBac.validate();
      // vérifier les annexes obligatoires
      if (this.validForm) {
        this.loader = true;
        let self = this;
        Promise.all([
          this.$storeResultatBac
            .postData()
            .then((reponse) => {
              if (reponse && reponse.data) {
                if (reponse.data.msg) {
                  this.alert.show = true;
                  this.alert.texte =
                    this.$storeUniversite.label.ChampsAnnexesObligatoires;
                  this.alert.type = "error";
                } else {
                  this.alert.show = true;
                  this.alert.texte = this.$storeUniversite.label.ResultatSoumis;
                  this.alert.type = "success";
                }
                this.$refs.childAnnexe.ChargerAnnexesResultatBac(
                  this.$storeResultatBac.data.idCrypte
                );
                this.$storeResultatBac.data = reponse.data.dto;
              }
            })
            .catch((error) => {
              // Gestion affichage erreur
              console.log(error);
            }),
        ])
          .then(() => {
            self.loader = false;
          })
          .catch(() => {
            self.loader = false;
            // Gestion affichage erreur
            console.log("Une erreur est survenue lors de la validation");
          });
      }
    },
  },
};
</script>
